var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.logoSrc)?_c('img',{staticClass:"file-type-icon",attrs:{"src":_vm.logoSrc,"alt":"","width":_vm.size,"height":_vm.size}}):_c('aha-icon',{staticClass:"file-type-icon",attrs:{"maintainColor":"","name":_vm.iconName,"width":_vm.size,"height":_vm.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }